
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11192",
                "data-name": "矩形 11192",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.196 -0.422)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_233",
        "data-name": "蒙版组 233",
        "class": "cls-2",
        "transform": "translate(-0.196 0.422)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "restaurants",
            "class": "cls-3",
            "d": "M173.679,67.06V58.118a1.482,1.482,0,0,0-1.574-1.229,2.15,2.15,0,0,0-1.937,1.565,7.319,7.319,0,0,0-.363,2.235,15.675,15.675,0,0,0-.121,4.024,1.924,1.924,0,0,0,1.816,1.677h1.211v.782a1.366,1.366,0,0,0-.969,1.229V73.43a1.415,1.415,0,0,0,1.574,1.453,1.464,1.464,0,0,0,1.574-1.453V68.4A1.825,1.825,0,0,0,173.679,67.06Zm-3.027-2.571a20.832,20.832,0,0,1,.121-3.912c.121-1.006.242-1.677.242-1.677s.242-1.006.969-1.006a.445.445,0,0,1,.484.559v7.041h-1.09C171.5,65.383,170.652,65.383,170.652,64.489Zm3.027,9.053s0,.335-.484.335-.484-.335-.484-.335V68.4s0-.335.484-.335.484.335.484.335Zm-8.838-16.653a.49.49,0,0,0-.363.671,26.4,26.4,0,0,1,.969,4.694,2.124,2.124,0,0,1-1.7,2.459V57.448a.551.551,0,0,0-.605-.559.627.627,0,0,0-.605.559v7.265a2.321,2.321,0,0,1-1.574-2.347,22.738,22.738,0,0,1,1.09-4.806.758.758,0,0,0-.484-.671c-.363,0-.605.224-.605.447A29,29,0,0,0,160,61.583a3.589,3.589,0,0,0,.242,2.459,3.739,3.739,0,0,0,2.421,1.677v1.453a1.366,1.366,0,0,0-.969,1.229V73.43a1.415,1.415,0,0,0,1.574,1.453,1.464,1.464,0,0,0,1.574-1.453V68.4a2.07,2.07,0,0,0-1.09-1.341V65.718a3.244,3.244,0,0,0,2.785-3.241,9.31,9.31,0,0,0-.484-3.018c-.363-1.341-.605-2.124-.605-2.124C165.446,57.112,165.2,56.889,164.841,56.889Zm-1.09,16.653s0,.335-.484.335-.484-.335-.484-.335V68.4s0-.335.484-.335.484.335.484.335Z",
            "transform": "translate(-154.694 -54.312)"
          }
        }
      ]
    }
  ]
})
    }
  